import React, { Fragment } from 'react';
import { createRoot } from 'react-dom/client';

import AppSummary from './components/AppSummary';
import BlogPosts from './components/BlogPosts';
import UserStatistics from './components/UserStatistics';
import MiniHeader from '../_shared/components/MiniHeader';
import TopAppsLine from '../_shared/components/TopAppsLine';
import SectionDivider from '../_shared/components/SectionDivider';
import AdditionalResources from '../_shared/components/AdditionalResources';
import AdditionalAppInsights from '../_shared/components/AdditionalAppInsights';
import CompetitorsComparisonsSection from '../_shared/components/CompetitorsComparisonsSection';
import useMobileView from '../../alchemy/сompetitive-intelligence-reports/shared/hooks/useMobileView';
import Container from '../../../components/Container';

import { rootNode, initParams } from './configs';

const { data, formId, portalId } = initParams;
const apps = [data];

const FinanceApps = () => {
  const isMobileView = useMobileView();

  return (
    <Fragment>
      <MiniHeader apps={apps} date={data.published_date} isMobileView={isMobileView} />
      <TopAppsLine apps={apps} isMobileView={isMobileView} />
      <AppSummary data={data} isMobileView={isMobileView} />
      <CompetitorsComparisonsSection
        competitors={data.top_competitors}
        comparisons={data.top_comparisons}
        isMobileView={isMobileView}
      />
      <div className="app-additional-info">
        <Container maxWidth={1248}>
          <UserStatistics data={data} isMobileView={isMobileView} />
          <AdditionalAppInsights
            formId={formId}
            portalId={portalId}
            buttons={data.click_baits_text}
          />
          <SectionDivider disableGutters />
          <AdditionalResources resources={data.additional_resources} />
          <SectionDivider disableGutters />
          <BlogPosts posts={data.sector_resources} />
        </Container>
      </div>
    </Fragment>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<FinanceApps />);
});
